import React, { useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LineDialog from "./AnsweredRequests/Dialog";
import moment from "moment";
import themeInfo from "../../../themes/themes";
import Link from "../../misc/Link";

const useStyles = makeStyles((theme) => ({
  requests: { fontSize: "large" },
  request: {
    marginBottom: theme.spacing(3),
  },
  viewResponse: {
    fontSize: "inherit",
    padding: 0,
  },
}));

export default function ShowRequests(props) {
  const classes = useStyles();
  const { request, requestsList, setRequests } = props;
  const [openDialog, setOpenDialog] = useState(false);
  const theme = process.env.REACT_APP_THEME;

  function onCloseLineDialog() {
    setOpenDialog(false);
  }

  function makeDialogLink(type) {
    const diff2 = moment(request.updated_at).add(8, "days");
    const diff = diff2.diff(moment(), "days");
    const showReviewAndAcceptMsg =
      type === "financing_application" &&
      request.status === "pending_customer_approval";

    return (
      <Link
        href=""
        className={classes.viewResponse}
        onClick={() => {
          setOpenDialog(true);
        }}
      >
        {!showReviewAndAcceptMsg && "View Response >"}
        {showReviewAndAcceptMsg && `You have ${diff} days to Review & Accept >`}
      </Link>
    );
  }

  return (
    <>
      <ul className={classes.requests}>
        <li className={classes.request}>
          The {themeInfo[theme].company} team has reviewed your recent change
          request.
          <br />
          {makeDialogLink(request?.type)}
        </li>
      </ul>
      <LineDialog
        open={openDialog}
        onClose={onCloseLineDialog}
        request={request}
        requestsList={requestsList}
        setRequests={setRequests}
      />
    </>
  );
}
